var App = App || {};

App.TestimonialsBand = (function ($) {
    "use strict";

    function init() {

        const testimonialsBands = $(".block.block-testimonials-band");
        if (testimonialsBands.length) {
            testimonialsBands.each(function () {
                InitCarousels($(this));
            });
        }
    }

    function InitCarousels(testimonialsBand) {
        const carousel = testimonialsBand.find(".testimonial-cards-list.splide");

        if (carousel.length) {
            const splideCarousel = new Splide(carousel[0], {
                pagination: true,
                type: 'fade',
                rewind: true,
                drag: false,
                snap: false,
                perMove: 1
            });

            splideCarousel.mount();
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.TestimonialsBand.init();
});